import styled, { keyframes } from 'styled-components';

import { colors } from 'styles/colors';

const textMain = colors.text['main-900'];
const textSub = colors.text['sub-500'];

const modalIn = keyframes`
  from { opacity: 0; transform: translateY(-10px); }
  to   { opacity: 1; transform: none; }
`;

export const ModalOverlay = styled.div<{ $sidebarWidth: number }>`
  display: flex;
  position: fixed;
  z-index: 900;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
  align-items: center;
  justify-content: center;
  padding-left: ${({ $sidebarWidth }) => $sidebarWidth}px;
`;

export const ModalBox = styled.div`
  background: ${colors.White};
  border-radius: 16px;
  padding: 28px;
  width: 520px;
  max-width: 92vw;
  box-shadow: 0 20px 48px rgba(10, 13, 20, 0.22);
  animation: ${modalIn} 0.2s ease;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 18px;
`;

export const ModalIconWrap = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: ${colors.Blue300};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const ModalTitle = styled.div`
  font-size: 15px;
  font-weight: 700;
  color: ${textMain};
  margin-bottom: 3px;
`;

export const ModalSubtitle = styled.div`
  font-size: 12px;
  color: ${textSub};
  line-height: 1.5;
`;

export const ModalListItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 13px;
  color: ${textSub};
  line-height: 1.6;

  &::before {
    content: '';
    display: block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${colors.Blue300};
    flex-shrink: 0;
    margin-top: 5px;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
`;
